// extracted by mini-css-extract-plugin
export default {"upper_part":"CookieModal_upper_part__1vS6O","btn_group":"CookieModal_btn_group__i7X90","details":"CookieModal_details__TKZC5","agree_btn":"CookieModal_agree_btn__KGgL-"};